import { getTokenQuery } from '~/utils';

export default ({ $auth, redirect, from, $RouteEnum }) => {
  if ($auth.isGuest) {
    redirect({ name: $RouteEnum.LOGIN, query: getTokenQuery(from) });
  }
};
